import React from 'react';
import {Link} from 'react-router-dom'

function Page404(props){
  return(
    <div className="p-4 w-100 text-white bg-dark d-flex flex-column justify-content-between" style={{minHeight:'82vh'}}>
      <h1 className="text-center display fw-bold">PAGE NOT FOUND...</h1>
      <Link to='/' className="btn btn-outline-light mx-auto my-3">Pixa Search <i className="fa fa-hand-o-left" aria-hidden="true"></i></Link>
    </div> 
  )
}

export default Page404